import React, { useCallback, useEffect, useMemo } from 'react';

import { useSelector } from 'react-redux';

import { AccordionPanel } from 'reaxl';
import { FilterCheckboxes } from 'reaxl-filters';

import getFilterTitle from '@/utilities/getFilterTitle';

import srpFiltersDuck from '@/ducks/srp/srpFiltersDuck.js';

import FilterPlaceholder from './FilterPlaceholder';

const FILTER_NAME = 'vehicleType';
const VEHICLE_STYLE_LABEL = 'Vehicle Style';

function VehicleTypeFilter({
    onOptionChange = () => { },
    onOptionsClear = () => { },
    handleShowExpansion = () => { },
}) {

    const vehicleTypeOptions = useSelector(srpFiltersDuck.selectors.getVehicleTypeOptions);
    const vehicleTypeValues = useSelector(srpFiltersDuck.selectors.getVehicleTypeValues);

    const isExpanded = useSelector((state) => srpFiltersDuck.selectors.isExpansionActive(state, FILTER_NAME));

    const filterValues = useMemo(
        () => ({ vehicleType: vehicleTypeValues }),
        [vehicleTypeValues]
    );

    const showFilter = useMemo(
        () => isExpanded && Object.keys(filterValues).length !== 0,
        [isExpanded, filterValues]
    );

    const title = useMemo(
        () => getFilterTitle(VEHICLE_STYLE_LABEL, vehicleTypeOptions),
        [vehicleTypeOptions]
    );

    const handleExpansion = useCallback(() => {
        handleShowExpansion(FILTER_NAME);
    }, [handleShowExpansion]);

    // Expand the panel if active options inside of it
    useEffect(() => {
        if (vehicleTypeValues.length > 0) {
            handleExpansion();
        }
    }, [vehicleTypeValues.length, handleExpansion]);

    const accordionProps = useMemo(
        () => ({
            'data-cmp': 'VehicleTypeFilter',
            title,
            contentPadding: 5,
            eventKey: FILTER_NAME,
            className: 'visual-checkboxes',
        }),
        [title]
    );

    const filterCheckboxesProps = useMemo(
        () => ({
            withAccordion: false,
            filter: vehicleTypeOptions,
            values: filterValues,
            onOptionChange,
            onOptionsClear,
        }),
        [vehicleTypeOptions, filterValues, onOptionChange, onOptionsClear]
    );

    return (
        <AccordionPanel {...accordionProps}>
            {!showFilter && <FilterPlaceholder uniqueKey={FILTER_NAME} />}
            {showFilter && <FilterCheckboxes {...filterCheckboxesProps} />}
        </AccordionPanel>
    );
}
export default React.memo(VehicleTypeFilter);
